"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (io, roomId) {
  return function (store) {
    return function (next) {
      return function (action) {
        //Handle: serverShared
        // An action within the async action that needs to be shared across the clients (e.g. notifying everyone that a player is RUNNING)
        //This needs to be here because we will want to emit sharedServer actions that are part of an asyncAction
        if (action.meta && action.meta.serverShared === true) {
          io.to(roomId).emit("actionToClient", action);
        }

        return next(action);
      };
    };
  };
};